// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { paste16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-paste': IconPaste;
    }
}

/**
 * The icon component for the 'paste' icon
 */
export class IconPaste extends IconSvg {
    public constructor() {
        super(paste16X16);
    }
}

registerIconSvg('icon-paste', IconPaste);
export const iconPasteTag = 'nimble-icon-paste';
